jQuery(document).ready(function($) {
  function GardpSliderHelper(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, options || {});
  }

  GardpSliderHelper.prevArrowMarkup = '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  GardpSliderHelper.nextArrowMarkup = '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

  GardpSliderHelper.initElements = function(elements, optionsFactory) {
    var nodes = [];

    if (elements && elements.jquery) {
      nodes = elements.toArray();
    } else if (elements && typeof elements.length === 'number') {
      nodes = Array.prototype.slice.call(elements);
    }

    return nodes.map(function(element, index) {
      var options = typeof optionsFactory === 'function' ? optionsFactory(element, index) : optionsFactory;
      var helper = new GardpSliderHelper(element, options);
      helper.init();
      return helper;
    });
  };

  GardpSliderHelper.autoInit = function() {
    return GardpSliderHelper.initElements(document.querySelectorAll('.gardp-slider-helper'));
  };

  GardpSliderHelper.prototype.getResolvedOptions = function() {
    var isPartialView = !!this.options.partialView;
    var desktopSlides = typeof this.options.slidesToShow === 'number' ? this.options.slidesToShow : (isPartialView ? 3.5 : 4);
    var tabletSlides = typeof this.options.tabletSlidesToShow === 'number' ? this.options.tabletSlidesToShow : (isPartialView ? 2.5 : 3);
    var mobileSlides = typeof this.options.mobileSlidesToShow === 'number' ? this.options.mobileSlidesToShow : 2;
    var slidesToScroll = typeof this.options.slidesToScroll === 'number' ? this.options.slidesToScroll : 2;

    return {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: desktopSlides,
      slidesToScroll: slidesToScroll,
      arrows: true,
      prevArrow: this.options.prevArrow || GardpSliderHelper.prevArrowMarkup,
      nextArrow: this.options.nextArrow || GardpSliderHelper.nextArrowMarkup,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: mobileSlides,
            slidesToScroll: 1
          }
        }
      ]
    };
  };

  GardpSliderHelper.prototype.init = function() {
    if (!this.$element.length || !$.fn.slick || this.$element.hasClass('slick-initialized')) {
      return false;
    }

    if (false !== this.options.containerClass) {
      this.$element.addClass(this.options.containerClass || 'highlights-slider-container');
    }

    this.$element.slick(this.getResolvedOptions());
    return true;
  };

  window.GardpSliderHelper = GardpSliderHelper;

  GardpSliderHelper.autoInit();

  $(".testimonial-slider-container").each(function() {
    var $slider = $(this);

    if ($slider.hasClass('slick-initialized')) {
      return;
    }

    if ($slider.find('.testimonial-slide').length < 2) {
      return;
    }

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      fade: true,
      cssEase: "ease",
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            autoplay: false,
          }
        },
      ],
    });
  });
});
